<div class="w-full">
    <div class="flex flex-col">
        <!-- Search input -->
        <div class="grid grid-cols-1 border-b border-gray-200">
            <input #searchWidgetInput class="col-start-1 row-start-1 h-12 w-full pl-11 pr-4 text-base text-gray-900 outline-none placeholder:text-gray-400 text-base" placeholder="Search..." role="searchbox" type="text" aria-expanded="false" aria-autocomplete="list" value="">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon" class="pointer-events-none col-start-1 row-start-1 ml-4 h-5 w-5 self-center text-gray-400">
                <path fill-rule="evenodd" d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z" clip-rule="evenodd"></path>
            </svg>
        </div>
        <!-- End of Search input -->
        <div class="flex transform-gpu divide-x divide-gray-100">
            <div class="w-full max-h-140 overflow-y-auto p-4 zuper-scrollbar space-y-2">
                <h3 class="text-base font-medium tracking-tight text-gray-500">Quick Actions</h3>
                <!-- Search results -->
                <ul role="listbox" class="min-h-80 max-h-96 transform-gpu scroll-py-3 overflow-y-auto" (keydown)="onKeyDown($event)">
                    <li *ngFor="let option of options; trackBy: trackbyFn; let i = index" role="option" [attr.tabindex]="i === activeIndex ? 0 : -1"
                    [class]="getListItemClass(i)"
                    (click)="selectOption(i)">
                    
                        <div class="flex h-10 w-10 flex-none items-center justify-center rounded-xl bg-product-light">
                            <em [class]="option.icon + ' text-3xl product'"></em>
                        </div>
                        <div class="ml-4 flex-auto">
                            <p class="text-base font-medium text-gray-700">{{ option.title }}</p>
                            <p class="text-md text-gray-500">{{ option.description }}</p>
                        </div>
                    </li>
    
                    <li #optionItems role="option" [attr.tabindex]="0 === activeIndex ? 0 : -1"
                    [class]="getListItemClass(0)"
                    (click)="selectOption(0)">
                        <div class="flex h-10 w-10 flex-none items-center justify-center rounded-xl bg-product-light">
                            <em class="ti ti-briefcase text-3xl product"></em>
                        </div>
                        <div class="ml-4 flex-auto">
                            <p class="text-base font-medium text-gray-700">Create a Job</p>
                            <p class="text-md text-gray-500">Add freeform text.</p>
                        </div>
                    </li>
                    <li #optionItems role="option" [attr.tabindex]="1 === activeIndex ? 0 : -1"
                    [class]="getListItemClass(1)"
                    (click)="selectOption(1)">
                        <div class="flex h-10 w-10 flex-none items-center justify-center rounded-xl bg-product-light">
                            <em class="ti ti-coin text-3xl product"></em>
                        </div>
                        <div class="ml-4 flex-auto">
                            <p class="text-base font-medium text-gray-700">Create a Quote</p>
                            <p class="text-md text-gray-500">Add freeform text.</p>
                        </div>
                    </li>
                    <li #optionItems role="option" [attr.tabindex]="2 === activeIndex ? 0 : -1"
                    [class]="getListItemClass(2)"
                    (click)="selectOption(2)">
                        <div class="flex h-10 w-10 flex-none items-center justify-center rounded-xl bg-product-light">
                            <em class="ti ti-users text-3xl product"></em>
                        </div>
                        <div class="ml-4 flex-auto">
                            <p class="text-base font-medium text-gray-700">Tom Cook</p>
                            <p class="text-md text-gray-500">This is a sample customer result</p>
                        </div>
                    </li>
    
                </ul>
                <!-- End of default Search results -->
            </div>

            <!-- PREVIEW RESULTS -->
            <div class="h-96 w-1/2 flex-none flex-col divide-y divide-gray-100 overflow-y-auto" [class]="showPreview ? 'flex': 'hidden'">
                <div class="flex-none p-6 text-center">
                    <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=facearea&amp;facepad=2&amp;w=256&amp;h=256&amp;q=80" alt="" class="mx-auto h-16 w-16 rounded-full">
                    <h2 class="mt-3 font-semibold text-gray-900">Tom Cook</h2>
                    <p class="text-sm/6 text-gray-500">Director, Product Development</p>
                </div>
                <div class="flex flex-auto flex-col justify-between p-6">
                    <dl class="grid grid-cols-1 gap-x-6 gap-y-3 text-base text-gray-700">
                        <dt class="col-end-1 font-semibold text-gray-900">Phone</dt>
                        <dd>881-460-8515</dd>
                        <dt class="col-end-1 font-semibold text-gray-900">URL</dt>
                        <dd class="truncate"><a href="https://example.com" class="text-indigo-600 underline">https://example.com</a></dd>
                        <dt class="col-end-1 font-semibold text-gray-900">Email</dt>
                        <dd class="truncate"><a href="mailto:tomcook@example.com" class="text-indigo-600 underline">tomcook&#64;example.com</a></dd>
                    </dl>
                    <button type="button" class="mt-6 w-full rounded-md bg-product-light px-3 py-2 text-base  product">View Details</button>
                </div>
            </div>
            <!-- END OF PREVIEW RESULTS -->
        </div>
        
        <div mat-dialog-actions class="flex flex-wrap items-center bg-gray-50 px-4 py-2 text-md text-gray-700 border-t border-gray-200">
            Use 
            <kbd class="ml-2 mr-0.5 flex w-5 h-5 items-center text-lg justify-center rounded border bg-white font-medium border-gray-300 text-gray-500">
                <em class="ti ti-arrow-up"></em>
            </kbd> 
            <kbd class="ml-0.5 mr-2 flex w-5 h-5 items-center text-lg justify-center rounded border bg-white font-medium border-gray-300 text-gray-500">
                <em class="ti ti-arrow-down"></em>
            </kbd> 
            <span class="sm:inline">to navigate,</span>
            <kbd class="mx-2 flex w-5 h-5 items-center text-lg justify-center rounded border bg-white font-medium border-gray-300 text-gray-500">
                <em class="ti ti-corner-down-left"></em>
            </kbd> 
            <span class="sm:inline">to open the record,</span>
            <kbd class="mx-2 flex w-8 h-5 items-center text-md justify-center rounded border bg-white font-medium border-gray-300 text-gray-500">
                esc
            </kbd> 
            <span class="sm:inline">to close</span>
        </div>
    </div>
</div>